import { styled, keyframes } from 'styled-components'

const width = '94%'
const maxWidth = '620px'
const height = '80%'
const marginTop = '10px'

export const StyledA = styled.a`
  display: flex;
  flex-direction: column;
  gap: 0.4em;
  align-items: center;
  justify-content: center;
  width: ${width};
  max-width: ${maxWidth};
  height: ${height};
  margin-top: ${marginTop};
  color: ${({ theme }) => theme.colors.palette.ghostWhite};
  text-decoration: none;
`

export const StyledTextTitleCat = styled.div`
  margin-top: 0.6em;
`

export const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3em;
  align-items: center;
  justify-content: center;
`

const pulse = keyframes`
  0% {
    opacity: 0.2;
    transform: scale(0.8);
  }

  50% {
    opacity: 1.0;
    transform: scale(1.2);
  }

  100% {
    opacity: 0.2;
    transform: scale(0.8);
  }
`

export const StyledCat = styled.img`
  height: 240px;
  pointer-events: none;
  animation: ${pulse} infinite 10s ease;
`

const swing = keyframes`
  from {
    transform: rotate(15deg);
  }

  to {
    transform: rotate(-15deg);
  }
`

export const StyledCcrate = styled.img`
  height: 280px;
  margin-top: 20px;
  pointer-events: none;
  backdrop-filter: blur(5px);
  border-radius: 16%;
  transform-origin: top;
  /* @media (prefers-reduced-motion: no-preference) {
    animation: ${swing} 3.5s ease-in-out infinite alternate-reverse;
  } */
`
